import gql from 'graphql-tag';

import dokkioObjectFragment from './dokkioObjectFragment';

export const taskFragment = gql`
  fragment taskFragment on Task {
    dokkioClass
    id
    accountID
    dokkioUserID
    name
    description
    sourceDokkioObjectID
    sourceDokkioObject {
      ...dokkioObjectFragment
    }
    dueAt
    completedAt
    rowCreateMethod
  }
  ${dokkioObjectFragment}
`;
export default taskFragment;
